import { Injectable } from '@angular/core'; 
import { LocalVariable } from './localvariable'

@Injectable() export class IsInfo { 
    isLoggedIn: boolean = LocalVariable.isLoggedIn(); 
    isPrenium: boolean = LocalVariable.isPrenium(); 
    isStravaConnected: boolean = LocalVariable.isStravaConnected(); 

    public checkInfo(){
        this.isLoggedIn = LocalVariable.isLoggedIn();
        this.isPrenium = LocalVariable.isPrenium(); 
        this.isStravaConnected = LocalVariable.isStravaConnected(); 
    }
}